import { useState, useEffect } from "react";
import API from "../../app/utils/api";

export const PRIMARY_COLOR = "#1a73e8";
export const PRIMARY_COLOR_DARK = "#002E6E";

// Fallback links in case API fails
const FALLBACK_LINKS = [
  {
    href: "https://analytics.premier-research.com/okta/sense/app/c20a232a-1418-4f3e-9937-fd8be9e189e1/overview",
    text: "Investigator Grant Forecasting",
  },
  {
    href: "https://analytics.premier-research.com/okta/sense/app/a6d024f1-ed67-4094-8db2-6366dc8341ca/sheet/7cc51354-ef05-4036-b435-1027cb2367dd/state/analysis",
    text: "Project Health Dashboard",
  },
  {
    href: "https://premier-research.okta.com/home/premierresearch_remarquerbm_1/0oa6b79srhDfYejZF1t7/aln6b7hthwvh8dWSD1t7",
    text: "Remarque",
  },
  {
    href: "https://ds.premier-research.com/ProtocolReader/",
    text: "SOE Extract Utility",
  },
  {
    href: "https://premierresearch.sharepoint.com/sites/PremierPredict",
    text: "Help / More Information",
  },
];

// Custom hook to fetch quick links
export const useQuickLinks = () => {
  const [links, setLinks] = useState(FALLBACK_LINKS);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    let isMounted = true;

    const fetchQuickLinks = async () => {
      try {
        const response = await API.getQuickLinks();
        
        // Transform the database response to match existing format
        const transformedLinks = response.data.map(link => ({
          href: link.linkUrl,
          text: link.linkLabel
        }));
        
        if (transformedLinks.length > 0 && isMounted) {
          setLinks(transformedLinks);
        }
      } catch (err) {
        console.error("Error fetching quick links:", err);
        // Keep fallback links on error
      } finally {
        if (isMounted) {
          setLoading(false);
        }
      }
    };

    fetchQuickLinks();

    return () => {
      isMounted = false;
    };
  }, []);

  return { links, loading };
};


export const LINKS = FALLBACK_LINKS;